import React from 'react';
import AsyncComponent from './async';
import {Route} from 'react-router-dom';

export default [
  <Route
    key="/business/campaign/ai-skin-diagnostic"
    path="business/campaign/ai-skin-diagnostic"
    element={<AsyncComponent />}
  />,
  <Route
    key="/business/campaign/skin-diagnostic"
    path="business/campaign/skin-diagnostic"
    element={<AsyncComponent />}
  />,
];
